"use strict";

angular
	.module('rmUser', []);

require('./controller');
require('./resources');
require('./directives');
require('./routes');